import React, { useContext } from 'react';

import { useIntl } from 'react-intl';

import { PageContext } from '@xingternal/pages-common';
import { Button } from '@xingternal/button';
import { PopOver } from '@xingternal/pop-over';

import { getMarketingPageUrl } from './utils';

import styles from './UpsellBanner.css';

const i18nKeys = {
  header: 'EP_NEWS_UPSELL_POPOVER_HEADER',
  body: 'EP_NEWS_UPSELL_POPOVER_BODY',
  btn: 'EP_NEWS_UPSELL_POPOVER_BUTTON',
};

type UpsellPopOverProps = {
  moduleName: string;
  popOver: PopOver;
};

type PopOver = {
  handleShow: () => void;
  handleHide: () => void;
  isInFlow?: boolean;
  triggerRef?: any;
  show: boolean;
};

const UpsellPopOver = ({ moduleName, popOver }: UpsellPopOverProps) => {
  const { pageContext } = useContext(PageContext);
  const intl = useIntl();

  const marketingPageUrl = getMarketingPageUrl({
    locale: intl.locale,
    focusType: pageContext?.focusType,
    moduleName,
    component: 'tooltip',
  });

  return (
    <PopOver
      isInFlow={true}
      onOutsideClick={popOver.handleHide}
      show={popOver.show}
      triggerRef={popOver.triggerRef}
      className={styles.popover}
      data-testid={'UPSELL_POPOVER'}
      onMouseLeave={popOver.handleHide}
    >
      <h1>{intl.formatMessage({ id: i18nKeys.header })}</h1>
      <p>{intl.formatMessage({ id: i18nKeys.body })}</p>

      <Button
        variant="proBusiness"
        size="medium"
        href={marketingPageUrl}
        target="_blank"
        rel="noreferrer noopener nofollow"
      >
        {intl.formatMessage({ id: i18nKeys.btn })}
      </Button>
    </PopOver>
  );
};

export default UpsellPopOver;
